import { Field } from 'redux-form'
import { defaultValidators } from '../../lib/validation'
import {
  Input,
  Select,
  Button,
  FormControlWrapper,
  Error,
  Info
} from '../uiLib'

const Register = props => {
  return (
    <div className="login-page">
      <p>{props.t('common:create-new-account-hint')}</p>
      <Info messages={[props.t('common:create-new-account-email-hint'), props.t('common:create-new-account-password-hint')]} />
      <Error message={props.t('common:create-new-account-immobilizer-warning')} />
      <div className="columns">
        <div className="column is-6">
          <form
            id="registration-form"
            onSubmit={props.handleSubmit(props._handleSubmit)}
            noValidate
            className="m-b-md m-t-md"
          >
            <Input
              name="user.username"
              id="username"
              type="email"
              label={props.t('common:username')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:username-tip')}
              help={props.t('common:username-help')}
              onPaste={e => e.preventDefault()}
              validate={[
                defaultValidators.required,
                defaultValidators.email,
                defaultValidators.emailMaxLength
              ]}
            />
            <Input
              name="user.confirm_username"
              id="confirm_username"
              type="email"
              label={props.t('common:username-confirm')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:username-confirm')}
              onPaste={e => e.preventDefault()}
              validate={[
                defaultValidators.required,
                defaultValidators.email,
                defaultValidators.emailMaxLength,
                defaultValidators.confirmEmailMatch
              ]}
            />
            <Input
              id="password"
              name="user.password"
              type="password"
              label={props.t('common:password')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:password-tip')}
              onPaste={e => e.preventDefault()}
              validate={[
                defaultValidators.required,
                defaultValidators.password
              ]}
            />
            <Input
              id="confirm_password"
              name="user.confirm_password"
              type="password"
              label={props.t('common:password-confirm')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:password-confirm')}
              onPaste={e => e.preventDefault()}
              validate={[
                defaultValidators.required,
                defaultValidators.password,
                defaultValidators.confirmPasswordMatch
              ]}
            />
            <Input
              id="first_name"
              name="user.first_name"
              label={props.t('common:firstname')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:firstname')}
              validate={[defaultValidators.required]}
            />
            <Input
              id="last_name"
              name="user.last_name"
              label={props.t('common:lastname')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:lastname')}
              validate={[defaultValidators.required]}
            />
            <Input
              id="phone"
              name="user.phone"
              label={props.t('common:phone')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:phone')}
              validate={[defaultValidators.required, defaultValidators.phone]}
            />
            <Input
              id="business_name"
              name="address.business_name"
              label={props.t('common:business-name')}
              required
              horizontal
              help={props.t('common:optional-field')}
              formComponent
              placeholder={props.t('common:business-name')}
            />
            <Input
              id="address1"
              name="address.address1"
              label={props.t('common:address1')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:address1')}
              validate={[defaultValidators.required]}
            />
            <Input
              id="address2"
              name="address.address2"
              label={props.t('common:address2')}
              required
              horizontal
              formComponent
              help={props.t('common:optional-field')}
              placeholder={props.t('common:address2')}
            />
            <Select
              id="country"
              name="address.country"
              label={props.t('common:country')}
              required
              formComponent
              horizontal
              placeholder={props.t('common:please-select')}
              validate={[defaultValidators.required]}
              values={props.countries}
            />
            <Input
              id="city"
              name="address.city"
              label={props.t('common:city')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:city')}
              validate={[defaultValidators.required]}
            />            
            <Select
              id="state"
              name="address.state"
              label={props.t('common:state-or-province')}
              required
              formComponent
              horizontal
              placeholder={props.t('common:please-select')}
              validate={[defaultValidators.required]}
              disabled={!props.regions.length}
              values={props.regions}
            />
            <Input
              id="zip"
              name="address.zip"
              label={props.t('common:postal')}
              required
              horizontal
              formComponent
              placeholder={props.t('common:postal')}
              validate={[
                defaultValidators.required,
                defaultValidators.zip
              ]}
            />
            <FormControlWrapper
              horizontal
              labelOffset
            >
              <label className="checkbox">
                <Field
                  name="user.opt_in_email"
                  id="opt_in_email"
                  component="input"
                  type="checkbox"
                  normalize={v => !!v}
                />
                &nbsp;{props.t('common:opt-in-email')}
              </label>
            </FormControlWrapper>
            { props.error &&
              <Error message={props.t(props.error)} />
            }
            <FormControlWrapper
              horizontal
              labelOffset
            >
              <Button
                disabled={props.submitting}
                loading={props.loading}
                outlined
                btType="primary"
              >
                {props.t('common:submit')}
              </Button>
            </FormControlWrapper>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Register



// WEBPACK FOOTER //
// ./components/Register/index.js